import React, {useContext, useEffect, useState, useCallback} from 'react'
import {Grid, FormControl, InputLabel, MenuItem, FormHelperText} from '@material-ui/core'
import {ReservationConfigurationContext} from './../../../../context/ReservationConfiguration'
import {getEntityObjects} from '../../../../state/entities/get-entity-objects-v2/actions'
import useGetEntityObjectsReducer, {
  ActionTypes as getReservationEntityItemsActionTypes,
} from '../../../../state/entities/get-entity-objects-v2/reducer'
import {getReservedForFieldValues} from '../../../../state/reservation/reserved-for-field-values/actions'
import useReservedForFieldValuesReducer from '../../../../state/reservation/reserved-for-field-values/reducer'
import '../../../ReservationBookings/StepActionFields/StepActionField.scss'
import {ReservationContext} from '../../../../context/Reservation'
import _ from 'lodash'
import Select from 'react-select'

export default function WMemoField({fieldId, fieldType, data}) {
  const [entityObjects, entityObjectsDispatch] = useGetEntityObjectsReducer()

  const [search, setSearch] = useState('')
  const [optionList, setOptionList] = useState([])
  const [list, reservedForFieldValuesDispatch] = useReservedForFieldValuesReducer()
  const newoptionList = []
  const {reservation, update} = useContext(ReservationContext)

  const getOptionList = userList => {
    if (userList) {
      if (userList && !userList.isLoading && userList.data) {
        const newOptionList = userList.data.map(fv => ({
          value: fv.id,
          label: fv.name,
        }))
        setOptionList(newOptionList)
      }
    }
    console.log(optionList)
  }

  const onChange = (e, fieldId) => {
    const updatedFields = reservation.additional_fields.map(fv => {
      if (fv.type === 'MultipleEntityListField' && fv.id === fieldId) {
        if (Array.isArray(e) && e.length > 0) {
          const values = e.map(item => item.label).join(',')
          fv.value = values
        } else {
          fv.value = ''
        }
      }
      return fv
    })

    update('additional_fields', updatedFields)
  }

  useEffect(() => {
    getReservedForFieldValues(
      reservedForFieldValuesDispatch,
      [fieldId],
      fieldType,
      search
    ).then(res => getOptionList(res))
    // eslint-disable-next-line
  }, [fieldType, reservedForFieldValuesDispatch, search, fieldId])

  const loadEntityObjects = useCallback(
    (group_id, params = {}) => {
      getEntityObjects(entityObjectsDispatch, group_id, params)
    },
    [entityObjectsDispatch]
  )

  useEffect(() => {
    let fIds = []
    if (_.isEmpty(data?.list_limit_attributes) && !_.isEmpty(data?.list_filters_attributes)) {
      fIds = data?.list_filters_attributes.map(val => val.type_id)
      loadEntityObjects(data?.description, {list_for_field: fIds})
    } else if (data?.list_limit_attributes?.length > 0) {
      loadEntityObjects(data?.description, {ids: data.list_limit_attributes, list_for_field: fIds})
    }
  }, [data, loadEntityObjects])

  return (
    <Grid item xs={6} className="select-search-container">
      <Select
        classNamePrefix="select"
        className="select-search search-border"
        isSearchable={true}
        isLoading={list.isLoading}
        labelId="demo-mutiple-name-label"
        id="demo-simple-select"
        placeholder={data.name}
        isClearable={true}
        options={optionList}
        onChange={e => {
          onChange(e, fieldId, fieldType)
        }}
        isMulti
        onInputChange={e => setSearch(e)}
      ></Select>
      <FormHelperText className="helper-text-margin">
        {!data.is_required ? 'optional' : ''}
      </FormHelperText>
    </Grid>
  )
}
